import type { FC, ReactNode } from "react";

export interface ChapterTooltipScoreLineProps {
  label?: ReactNode;
  passRate: number | null | undefined;
  isLoading?: boolean;
}

export const ChapterTooltipScoreLine: FC<ChapterTooltipScoreLineProps> = ({
  label,
  passRate,
  isLoading,
}) => {
  return (
    <div className="overflow-hidden">
      <span className="font-semibold">{label || "Score"}:</span>{" "}
      <span className="truncate">
        {passRate === undefined && isLoading ? "Loading..." : null}
        {passRate === undefined && !isLoading ? "Not graded yet" : null}
        {passRate === null ? "Not enough signal" : null}
        {typeof passRate === "number"
          ? `${(passRate * 100).toFixed(0)}%`
          : null}
      </span>
    </div>
  );
};
